var map = {
	"./fankui_banner.jpg": "fb35",
	"./fankui_banner_en.jpg": "0695",
	"./fankui_banner_es.jpg": "8970",
	"./fankui_banner_hk.jpg": "7bd1",
	"./fankui_banner_pt.jpg": "41bd",
	"./fankui_banner_tr.jpg": "7f63"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "228a";